import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const colorOptions = [
  'primary',
  'info',
  'success',
  'warning',
  'danger',
  'default'
];

class Switch extends React.Component {

  static get defaultProps() {
    return {
      animate: true,
      disabled: false,
      indeterminate: false,
      labelText: ' ',
      offColor: 'default',
      offText: 'OFF',
      onColor: 'primary',
      onText: 'ON',
      readonly: false,
      size: 'normal'
    };
  }

  static get propTypes() {
    return {
      animate: PropTypes.bool,
      disabled: PropTypes.bool,
      indeterminate: PropTypes.bool,
      labelText: PropTypes.string,
      offColor: PropTypes.oneOf(colorOptions),
      offText: PropTypes.string,
      onChange: PropTypes.func,
      onColor: PropTypes.oneOf(colorOptions),
      onText: PropTypes.string,
      readonly: PropTypes.bool,
      size: PropTypes.oneOf(['mini', 'small', 'normal', 'large']),
      value: PropTypes.bool.isRequired
    };
  }

  constructor(props, context) {
    super(props, context);

    this._handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    !this.props.disabled && !this.props.readonly && this.props.onChange && this.props.onChange(!this.props.value);
  }

  render() {
    const {
      animate,
      disabled,
      indeterminate,
      labelText,
      offColor,
      offText,
      onColor,
      onText,
      readonly,
      size,
      value
    } = this.props;

    const className = classNames('bootstrap-switch', 'bootstrap-switch-wrapper', {
      'bootstrap-switch-animate': animate
    }, {
      'bootstrap-switch-disabled': disabled
    }, {
      'bootstrap-switch-indeterminate': indeterminate
    }, {
      'bootstrap-switch-off': !value
    }, {
      'bootstrap-switch-on': value
    }, {
      'bootstrap-switch-readonly': readonly
    }, {
      [`bootstrap-switch-${size}`]: size
    });

    const containerMarginLeft = value
      ? '0px'
      : '-53px';

    return (
      <div className={className} onClick={this._handleToggle} style={{
        width: '108px'
      }}>
        <div className="bootstrap-switch-container" style={{
          width: '159px',
          marginLeft: containerMarginLeft
        }}>
          <span className={`bootstrap-switch-handle-on bootstrap-switch-${onColor}`} style={{
            width: '53px'
          }}>
            {onText}
          </span>
          <span className="bootstrap-switch-label" style={{
            width: '53px'
          }}>{labelText || ' '}</span>
          <span className={`bootstrap-switch-handle-off bootstrap-switch-${offColor}`} style={{
            width: '53px'
          }}>
            {offText}
          </span>
        </div>
      </div>
    );
  }
}

export default Switch;
